<div class="form-parent" *ngIf="hasPermission">
       <kgrid [apiName]="apiName"
       [noAutoFitColumns]="true"
       [label]="label"
       [areaName]="areaName"
       [name]="apiName"
       reportName="CostGroup"
       pathPreFix="SALE"
       [isMulti]="true"
       [IgnoreDeletePermission]= "IgnoreDelete"
       [deleteMessage]="deleteMessage"
       [inputEditorform]="inputEditorform"
       [isAdd]="isAdd"
       [isEdit]="isEdit"
       [isDelete]="isDelete">
</kgrid>
</div>